const activeClass = 'activeClass';

const scroll = {
  btn: document.getElementById('jsProdBtn') as HTMLElement | null,

  init(): void {
    if (!this.btn) return;

    this.setScroll();
    this.checkScroll();
  },

  setScroll(): void {
    window.addEventListener('scroll', () => {
      this.checkScroll();
    });
  },

  checkScroll(): void {
    if (!this.btn) return;

    const isScrolled = window.scrollY >= 1200;
    this.btn.classList.toggle(activeClass, isScrolled);
  },
};

export default scroll;
